export const HOME = '/'
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const FOOTER = '/'
export const SEARCH = '/search'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = '/pwforget'
export const PASSWORD_CHANGE = '/pwchange'
export const CREATE_PROJECT = '/createproject'
export const MY_REVIEWS = '/account/reviews'
export const MY_PROJECTS = '/account/projects'
export const PROJECT_LIST = '/:user/projects'
export const REVIEW_LIST = '/:user/reviews'
export const MORE_INFO = '/register'
